module.exports = __webpack_public_path__ + "static/graph-208648a265093d9f47e171bdb1a30255.png";